import { i18n } from '@/core/lib/i18n';
import { getInfoCenterUrl } from '@/core/lib/url';
import { BrandType, EnumLanguage } from '@/interface/enum';

const cashoutUrlMapping: Partial<Record<BrandType, Record<EnumLanguage, string>>> = {
    [BrandType.Sbobet]: {
        [EnumLanguage.EN]: '/article/what-is-cash-out-7298.html',
        [EnumLanguage.ZH_CN]: '/article/%e4%bb%80%e4%b9%88%e6%98%af%e6%92%a4%e5%8d%95%e5%a5%97%e7%8e%b0%ef%bc%9f-9155.html',
        [EnumLanguage.ID_ID]: '/article/apa-itu-fitur-bayar-sekarang-7326.html',
        [EnumLanguage.TH_TH]: '/article/%e0%b8%88%e0%b9%88%e0%b8%b2%e0%b8%a2%e0%b8%ad%e0%b8%ad%e0%b8%81%e0%b8%84%e0%b8%b7%e0%b8%ad%e0%b8%ad%e0%b8%b0%e0%b9%84%e0%b8%a3-7328.html',
        [EnumLanguage.VI_VN]: '/article/r%c3%bat-s%e1%bb%9bm-l%c3%a0-g%c3%ac-7350.html',
        [EnumLanguage.JA_JP]: '/article/%e3%82%ad%e3%83%a3%e3%83%83%e3%82%b7%e3%83%a5%e3%82%a2%e3%82%a6%e3%83%88%e3%81%a8%e3%81%af%ef%bc%9f-10528.html',
        [EnumLanguage.KO_KR]: '/article/%ec%ba%90%ec%8b%9c-%ec%95%84%ec%9b%83%ec%9d%b4-%eb%ac%b4%ec%97%87%ec%9d%b8%ea%b0%80%ec%9a%94-7706.html',
        [EnumLanguage.MY_MM]: '/article/what-is-cash-out-7298.html',
        [EnumLanguage.PT_BR]: '/article/what-is-cash-out-7298.html',
        [EnumLanguage.KM_KH]: '/article/what-is-cash-out-7298.html',
        [EnumLanguage.BN_BD]: '/article/what-is-cash-out-7298.html',
        [EnumLanguage.MS_MY]: '/article/what-is-cash-out-7298.html',
    },
    [BrandType.Sbotop]: {
        [EnumLanguage.EN]: '/article/what-is-cash-out-11153.html',
        [EnumLanguage.ZH_CN]: '/article/%e4%bb%80%e4%b9%88%e6%98%af%e6%92%a4%e5%8d%95%e5%a5%97%e7%8e%b0%ef%bc%9f-11154.html',
        [EnumLanguage.ID_ID]: '/article/apa-itu-fitur-bayar-sekarang-11155.html',
        [EnumLanguage.TH_TH]: '/article/%e0%b8%88%e0%b9%88%e0%b8%b2%e0%b8%a2%e0%b8%ad%e0%b8%ad%e0%b8%81%e0%b8%84%e0%b8%b7%e0%b8%ad%e0%b8%ad%e0%b8%b0%e0%b9%84%e0%b8%a3-11156.html',
        [EnumLanguage.VI_VN]: '/article/r%c3%bat-s%e1%bb%9bm-l%c3%a0-g%c3%ac-8347.html',
        [EnumLanguage.JA_JP]: '/article/%e3%82%ad%e3%83%a3%e3%83%83%e3%82%b7%e3%83%a5%e3%82%a2%e3%82%a6%e3%83%88%e3%81%a8%e3%81%af%ef%bc%9f-11157.html',
        [EnumLanguage.KO_KR]: '/article/%ec%ba%90%ec%8b%9c-%ec%95%84%ec%9b%83%ec%9d%b4-%eb%ac%b4%ec%97%87%ec%9d%b8%ea%b0%80%ec%9a%94-11158.html',
        [EnumLanguage.MY_MM]: '/article/%e1%80%84%e1%80%bd%e1%80%b1%e1%80%80%e1%80%bc%e1%80%ad%e1%80%af%e1%80%9a%e1%80%b0%e1%80%81%e1%80%bc%e1%80%84%e1%80%ba%e1%80%b8%e1%80%86%e1%80%ad%e1%80%af%e1%80%90%e1%80%ac-%e1%80%98%e1%80%ac%e1%80%9c%e1%80%b2%e1%81%8b-11159.html',
        [EnumLanguage.PT_BR]: '/article/what-is-cash-out-11153.html',
        [EnumLanguage.KM_KH]: '/article/what-is-cash-out-11153.html',
        [EnumLanguage.BN_BD]: '/article/what-is-cash-out-11153.html',
        [EnumLanguage.MS_MY]: '/article/what-is-cash-out-11153.html',
    },
};

export function getCashOutLearnMoreUrl(brandType: BrandType, isMainDomain: boolean): string {
    const infoCenterUrl = getInfoCenterUrl(brandType, isMainDomain);
    const path = cashoutUrlMapping[brandType]?.[i18n.locale.value] ?? '';
    return `${infoCenterUrl}${path}`;
}

const jackpotTncUrlMapping: Partial<Record<BrandType, Partial<Record<EnumLanguage, string>>>> = {
    [BrandType.Sbobet]: {
        [EnumLanguage.EN]: '/article/12430.html',
        [EnumLanguage.ZH_CN]: '/article/12433.html',
        [EnumLanguage.ID_ID]: '/article/12434.html',
        [EnumLanguage.TH_TH]: '/article/12438.html',
        [EnumLanguage.VI_VN]: '/article/12439.html',
        [EnumLanguage.JA_JP]: '/article/12435.html',
        [EnumLanguage.KO_KR]: '/article/12436.html',
        [EnumLanguage.MY_MM]: '/article/12432.html',
        [EnumLanguage.PT_BR]: '/article/12437.html',
        [EnumLanguage.KM_KH]: '/article/12430.html',
        [EnumLanguage.BN_BD]: '/article/12430.html',
        [EnumLanguage.MS_MY]: '/article/12430.html',
    },
    [BrandType.Sbotop]: {
        [EnumLanguage.EN]: '/article/12645.html',
        [EnumLanguage.ZH_CN]: '/article/12648.html',
        [EnumLanguage.ID_ID]: '/article/12649.html',
        [EnumLanguage.TH_TH]: '/article/12653.html',
        [EnumLanguage.VI_VN]: '/article/12654.html',
        [EnumLanguage.JA_JP]: '/article/12650.html',
        [EnumLanguage.KO_KR]: '/article/12651.html',
        [EnumLanguage.MY_MM]: '/article/12647.html',
        [EnumLanguage.PT_BR]: '/article/12652.html',
        [EnumLanguage.KM_KH]: '/article/12645.html',
        [EnumLanguage.BN_BD]: '/article/12645.html',
        [EnumLanguage.MS_MY]: '/article/12645.html',
    },
};

export function getJackpotTncUrl(brandType: BrandType, isMainDomain: boolean): string {
    const infoCenterUrl = getInfoCenterUrl(brandType, isMainDomain);
    const path = jackpotTncUrlMapping[brandType]?.[i18n.locale.value] ?? '';
    return `${infoCenterUrl}${path}`;
}

const fantasySelectionTncUrlMapping: Partial<Record<BrandType, Record<EnumLanguage, string>>> = {
    [BrandType.Sbotop]: {
        [EnumLanguage.EN]: 'https://help.beradapedagang.com/article/14328.html',
        [EnumLanguage.MY_MM]: 'https://help.beradapedagang.com/article/14340.html',
        [EnumLanguage.ID_ID]: 'https://help.bermainolahragatop.com/article/14341.html',
        [EnumLanguage.JA_JP]: 'https://help.beradapedagang.com/article/14342.html',
        [EnumLanguage.KM_KH]: 'https://help.beradapedagang.com/article/14343.html',
        [EnumLanguage.KO_KR]: 'https://help.beradapedagang.com/article/14344.html',
        [EnumLanguage.TH_TH]: 'https://help.bermainolahragatop.com/article/14345.html',
        [EnumLanguage.VI_VN]: 'https://help.beradapedagang.com/article/14346.html',
        [EnumLanguage.ZH_CN]: 'https://help.beradapedagang.com/article/14328.html',
        [EnumLanguage.PT_BR]: 'https://help.beradapedagang.com/article/14328.html',
        [EnumLanguage.BN_BD]: 'https://help.beradapedagang.com/article/14328.html',
        [EnumLanguage.MS_MY]: 'https://help.beradapedagang.com/article/14328.html',
    },
    [BrandType.Sbobet]: {
        [EnumLanguage.EN]: 'https://help.kamala23.com/article/14063.html',
        [EnumLanguage.MY_MM]: 'https://help.kamala23.com/article/14075.html',
        [EnumLanguage.ID_ID]: 'https://help.kamala23.com/article/14076.html',
        [EnumLanguage.JA_JP]: 'https://help.kamala23.com/article/14077.html',
        [EnumLanguage.KM_KH]: 'https://help.kamala23.com/article/14078.html',
        [EnumLanguage.KO_KR]: 'https://help.kamala23.com/article/14079.html',
        [EnumLanguage.TH_TH]: 'https://help.kamala23.com/article/14080.html',
        [EnumLanguage.VI_VN]: 'https://help.kamala23.com/article/14081.html',
        [EnumLanguage.ZH_CN]: 'https://help.kamala23.com/article/14063.html',
        [EnumLanguage.PT_BR]: 'https://help.kamala23.com/article/14063.html',
        [EnumLanguage.BN_BD]: 'https://help.kamala23.com/article/14063.html',
        [EnumLanguage.MS_MY]: 'https://help.kamala23.com/article/14063.html',
    },
};

export function getFantasySelectionTncUrl(brandType: BrandType): string {
    const languageMapping = fantasySelectionTncUrlMapping[brandType];
    if (!languageMapping) {
        return fantasySelectionTncUrlMapping[BrandType.Sbobet]?.[EnumLanguage.EN] ?? '';
    }

    return languageMapping[i18n.locale.value] ?? languageMapping[EnumLanguage.EN] ?? '';
}
